import fieldSettingsModalTemplate from '../views/definition-modal.tpl.html';
import customFieldDefintionModalTemplate from '../views/customfield-modal.tpl.html';
import AlGuestlistFormFieldDefinitionModalController from './definition-modal';
import AlGuestlistFormFieldCustomFieldModalController from './custom-field-modal';

export default class AlGuestlistFormFieldSelectorComponentController {

    constructor($scope, $injector, $element, Alert) {
        this.scope = $scope;
        this.injector = $injector;
        this.element = $element;
        this.translate = this.injector.get('$translate');
        this.api = this.injector.get('$http');
        this.log = this.injector.get('$log');
        this.filter = this.injector.get('$filter');
        this.guestlistActionService = this.injector.get('GuestlistActionService');
        this.modal = this.injector.get('$uibModal');
        this.disableCustomEdit = false;
        this.alert = Alert;
        this.isUpdatedByGroup = false;

        this._reset();
        this._initWatchers();
    }

    // Public methods
    changeCurrentFilter(filter) {
        this.currentFilter = filter.key;
        this.selectableFieldsSearch = '';
        this._updateSelectableFields();
    }

    handleFieldGroupToggle(groupKey) {

        const translatedValue = (path) => {
            return this.translate.instant(`guestlists.editor.components.ask-to-remove-fields-group-from-fieldset.${path}`);
        };

        let newGroupMode = !!_.get(this.selectedGroupsInputModels, groupKey);
        if (!newGroupMode) {
            this.alert.animatedAlert(
                translatedValue('title'),
                translatedValue('content'),
                'attention',
                {
                    confirmButtonText: translatedValue('confirm'),
                    cancelButtonText: translatedValue('cancel'),
                    wait: true
                }).then(() => {
                this.handleGroupToggle(newGroupMode, groupKey)
            }, () => {
                this.selectedGroupsInputModels[groupKey] = true;
                newGroupMode = !!_.get(this.selectedGroupsInputModels, groupKey);
                this.handleGroupToggle(newGroupMode, groupKey)
            });
        } else {
            this.handleGroupToggle(newGroupMode, groupKey)
        }
    }

    handleGroupToggle(newGroupMode, groupKey) {
        _.each(this.selectableFields, (groupInfo) => {
            if (groupInfo.key === groupKey) {
                _.each(groupInfo.fields, (field) => {
                    if (this.selectedFieldsInputModels[field.slug] !== newGroupMode) {
                        this.selectedFieldsInputModels[field.slug] = newGroupMode;
                        this.handleFieldToggle(field.slug, true);
                    }
                });
            }
        });
        this._triggerDefinitionUpdate();
    }

    handleFieldToggle(fieldSlug, isUpdatedByGroup = false) {
        this.isUpdatedByGroup = isUpdatedByGroup;
        if (this.selectedFieldsInputModels[fieldSlug]) {
            this._addFieldToCurrentDefinition(fieldSlug);
        } else {
            this._removeFieldFromCurrentDefinition(fieldSlug);
        }

        this._checkWholeFieldGroupStates();
        this._triggerDefinitionUpdate();
    }

    getDefinitionFieldTypeReadable(item) {
        if (item.auto_fill && !item.locked) {
            return this.translate.instant('guestlists.editor.components.form-field-selector.apiSettingTypes.read_and_update');
        } else if (item.auto_fill) {
            return this.translate.instant('guestlists.editor.components.form-field-selector.apiSettingTypes.only_read');
        } else if (!item.locked) {
            return this.translate.instant('guestlists.editor.components.form-field-selector.apiSettingTypes.edit_only');
        } else {
            return this.translate.instant('guestlists.editor.components.form-field-selector.apiSettingTypes.no_action');
        }
    }

    openFieldSettings(field) {
        this.modal.open({
            templateUrl: fieldSettingsModalTemplate,
            controller: AlGuestlistFormFieldDefinitionModalController,
            controllerAs: 'vm',
            resolve: {
                fieldConfig: () => {
                    return _.cloneDeep(this.availableFields[field.slug]);
                },
                currentDefinition: () => {
                    return _.cloneDeep(_.first(this.filter('filter')(this.internalDefintion, {slug: field.slug}, true)));
                }
            }
        }).result.then((result) => {
            let definitionToReplace = _.first(this.filter('filter')(this.internalDefintion, {slug: field.slug}, true)),
                indexToReplace = this.internalDefintion.indexOf(definitionToReplace);

            if (indexToReplace !== -1) {
                this.internalDefintion[indexToReplace] = result;
            }
        }, () => {

        });
    }

    changeCustomFieldDefinition(field) {
        if (!field.isCustomField) {
            this.log.info('Selected field is no custom field: ' + field.key);
            return;
        }

        this._openCustomFieldModal(this.customFieldDefinitions.definitions[field.customFieldInformation.group][field.customFieldInformation.number]).then((customFieldResult) => {
            switch (customFieldResult.action) {
                case 'save':
                    this._triggerCustomFieldUpdate('update', field.customFieldInformation.group, customFieldResult.data, field.customFieldInformation.number);
                    break;
                case 'delete':
                    this._triggerCustomFieldUpdate('delete', field.customFieldInformation.group, customFieldResult.data, field.customFieldInformation.number);
                    break;
                default:
                    this.log.info('Invalid action given from custom-field modal: ' + customFieldResult.action);
                    break;
            }
        }, () => {

        });
    }

    addNewCustomField() {
        this._openCustomFieldModal({
            name: this.newCustomFieldName
        }, true).then((customFieldResult) => {
            if (customFieldResult.action === 'save') {
                this._triggerCustomFieldUpdate('add', customFieldResult.data.group, customFieldResult.data);
            } else {
                this.log.info('Invalid action given from custom-field modal: ' + customFieldResult.action);
            }

            this.selectableFieldsSearch = customFieldResult.data.name;
            this.newCustomFieldName = '';
            this.scope.$applyAsync();

            this._scrollToTop();
        }, () => {

        });
    }

    // Internal methods
    _openCustomFieldModal(currentDefinition, notExists) {
        return this.modal.open({
            templateUrl: customFieldDefintionModalTemplate,
            controller: AlGuestlistFormFieldCustomFieldModalController,
            controllerAs: 'vm',
            resolve: {
                currentDefinition: () => {
                    return _.cloneDeep(currentDefinition);
                },
                alreadyExists: () => {
                    return !notExists;
                },
                fieldAvailabilities: () => {
                    return this.customFieldDefinitions.availability;
                }
            }
        }).result;
    }

    _triggerCustomFieldUpdate(action, fieldGroup, fieldDefinition, fieldNumber) {
        this.onCustomFieldChange({
            action,
            group: fieldGroup,
            definition: fieldDefinition,
            number: fieldNumber
        });
    }

    _addFieldToCurrentDefinition(fieldSlug) {
        this._removeFieldFromCurrentDefinition(fieldSlug);
        const fieldToAdd = _.cloneDeep(this.availableFields[fieldSlug]);

        this.internalDefintion.push({
            slug: fieldSlug,
            label: fieldToAdd.default_label,
            description: '',
            required: false,
            auto_fill: true,
            locked: false,
            unique: false,
            unique_count: 1
        })
    }

    _removeFieldFromCurrentDefinition(fieldSlug) {
        const translatedValue = (path) => {
            return this.translate.instant(`guestlists.editor.components.ask-to-remove-field-from-fieldset.${path}`);
        };

        if (this.internalDefintion) {
            const itemToRemove = _.first(this.filter('filter')(this.internalDefintion, {slug: fieldSlug}, true)),
                indexToRemove = this.internalDefintion.indexOf(itemToRemove);

            if (indexToRemove !== -1) {
                if (this.guestlist && this.isFieldUsedForRegistration(fieldSlug) && !this.isUpdatedByGroup) {
                    this.alert.animatedAlert(
                        translatedValue('title'),
                        translatedValue('content'),
                        'attention',
                        {
                            confirmButtonText: translatedValue('confirm'),
                            cancelButtonText: translatedValue('cancel'),
                            wait: true
                        }).then(() => {
                        this.internalDefintion.splice(indexToRemove, 1);
                        this._triggerDefinitionUpdate();
                    }, () => {
                    });
                } else {
                    this.internalDefintion.splice(indexToRemove, 1);
                }
            }
        }
    }

    isFieldUsedForRegistration(fieldSlug) {
        let fieldExistInRegistrationField = false;
        let fieldPath = fieldSlug.split(".");
        let guestlistFormFields = this.guestlist.fields;
        let representativeFields = this.guestlist.settings.representative_fields;
        let recommendationFields = this.guestlist.settings.recommendations_fields;
        let registrationGuestFields = this.guestlist.settings.registration_guest_fields;
        let field = fieldPath.pop();
        let group = fieldPath.shift();

        // check form fields
        if (guestlistFormFields[group] && guestlistFormFields[group][field]) {
            fieldExistInRegistrationField = true;
        }

        // check for representative fields
        if (this.fieldSlugExistInData(representativeFields, fieldSlug)) {
            fieldExistInRegistrationField = true;
        }

        // check for recommendation fields
        if (this.fieldSlugExistInData(recommendationFields, fieldSlug)) {
            fieldExistInRegistrationField = true;
        }

        // check for registration guest fields
        if (this.fieldSlugExistInData(registrationGuestFields, fieldSlug)) {
            fieldExistInRegistrationField = true;
        }

        return fieldExistInRegistrationField
    }

    fieldSlugExistInData(data, fieldSlug) {
        let exist = false;
        data.forEach(function (element) {
            if (element.slug === fieldSlug) {
                exist = true;
            }
        });
        return exist
    }

    _reset() {
        this.currentFilter = '';
        this.availableFilters = [];
        this.selectableFields = {};
        this.currentDefinition = [];
        this.internalDefinition = {};

        this.internalDefintion = [];

        this.customFieldDefinitions = {};
        this.availableFields = {};
        this.selectedFields = [];
        this.selectableFieldsSearch = '';
        this.selectedFieldsSearch = '';

        this.selectedFieldsInputModels = {};
        this.selectedGroupsInputModels = {};
        this.newCustomFieldName = '';
    }

    _updateSelectableFields() {
        this.selectableFields = {};
        const customFieldRegex = /^(rsvp|contact)\.custom_([0-9]{1,2})$/;

        const curFilter = _.first(_.filter(this.availableFilters, (filter) => {
            return filter.key === this.currentFilter;
        }));

        _.each(this.availableFields, (field, fieldSlug) => {
            if (!curFilter
                || !(
                    curFilter.type === 'all'
                    || (curFilter.type === 'all_configured' && _.isArray(this.globalSelectedFields) && this.globalSelectedFields.indexOf(fieldSlug) !== -1)
                    || (curFilter.type === 'group' && field.group === curFilter.extended.groupKey)
                )
            ) {
                return;
            }

            if (_.isUndefined(this.selectableFields[field.group])) {
                this.selectableFields[field.group] = {
                    key: field.group,
                    label: field.groupLabelOverride ? field.groupLabelOverride : this.translate.instant(`guestlists.editor.components.form-field-selector.fieldGroups.${field.group}`),
                    fields: []
                }
            }

            const newField = {
                slug: fieldSlug,
                isCustomField: customFieldRegex.test(fieldSlug) && !this.disableCustomEdit,
                enabledInMain: (this.globalSelectedFields && this.globalSelectedFields.indexOf(fieldSlug) !== -1),
                label: field.default_label
            };

            if (newField.isCustomField) {
                const regexParts = customFieldRegex.exec(fieldSlug);

                newField.customFieldInformation = {
                    group: regexParts[1],
                    number: regexParts[2]
                }
            }

            this.selectableFields[field.group].fields.push(newField);
            this.selectableFields[field.group].fields = this.filter('filter')(_.sortBy(this.selectableFields[field.group].fields, [field => {
                return field.label ? field.label.toLowerCase() : '';
            }]), this.selectableFieldsSearch);

            if (_.isEmpty(this.selectableFields[field.group].fields)) {
                delete this.selectableFields[field.group];
            }
        });

        this.selectableFields = _.sortBy(this.selectableFields, ['label']);

        this._initFilters();
        this._checkWholeFieldGroupStates();
    }

    _initFromAvailableFields() {
        this._initFilters();
        this._updateSelectableFields();
        this._initCheckboxModels();

        this._updateCurrentStateByCurrentDefinition();
    }

    _initFilters() {
        this.availableFilters = [
            {
                key: 'all',
                label: this.translate.instant('guestlists.editor.components.form-field-selector.filters.all'),
                type: 'all'
            }
        ];

        if (this.globalSelectedFields && this.globalSelectedFields.length > 0) {
            this.availableFilters.push({
                key: 'all_configured',
                label: this.translate.instant('guestlists.editor.components.form-field-selector.filters.all_configured'),
                type: 'all_configured'
            });
        }

        const availableFieldGroups = {};
        let customFilters = [];

        _.each(this.availableFields, (field) => {
            if (_.isUndefined(availableFieldGroups[field.group])) {
                availableFieldGroups[field.group] = {
                    key: field.group,
                    label: field.groupLabelOverride ? field.groupLabelOverride : this.translate.instant(`guestlists.editor.components.form-field-selector.fieldGroups.${field.group}`)
                };
            }
        });

        _.each(availableFieldGroups, (group) => {
            customFilters.push({
                key: `group_${group.key}`,
                label: group.label,
                type: 'group',
                extended: {
                    groupKey: group.key
                }
            })
        });

        customFilters = _.sortBy(customFilters, ['label']);

        this.availableFilters = this.availableFilters.concat(customFilters);

        let currentFilterValid = false;

        _.each(this.availableFilters, (filter) => {
            if (filter.key === this.currentFilter) {
                currentFilterValid = true;
            }
        });

        if (!currentFilterValid) {
            this.currentFilter = 'all';
        }
    }

    _initWatchers() {
        this.scope.$watch(() => {
            return this.availableFields;
        }, () => {
            this._initFromAvailableFields();
        });
        this.scope.$watch(() => {
            return this.globalSelectedFields;
        }, () => {
            this._updateSelectableFields();
        });

        this.scope.$watch(() => {
            return this.selectableFieldsSearch;
        }, () => {
            if (this.selectableFieldsSearch) {
                this.currentFilter = 'all';
            }
            this._updateSelectableFields();
        });

        this.scope.$watch(() => {
            return this.currentDefinition;
        }, (newVal, oldVal) => {
            this.internalDefintion = _.cloneDeep(this.currentDefinition);
            this._updateCurrentStateByCurrentDefinition();
        }, true);

        this.scope.$watch(() => {
            return this.internalDefintion;
        }, (newVal, oldVal) => {
            if (!_.isEqual(newVal, oldVal) && this.onDefinitionUpdate) {
                this._triggerDefinitionUpdate();
            }
        }, true);
    }

    _triggerDefinitionUpdate() {
        this._updateCurrentStateByCurrentDefinition();
        this.onDefinitionUpdate({
            newDefinition: this.internalDefintion
        });

        const $draggableContainer = jQuery(`#${this.idPrefix}draggable`);

        if ($draggableContainer.length > 0) {
            $draggableContainer.sortable('refresh');
        }
    }

    _updateCurrentStateByCurrentDefinition() {
        if (this.internalDefintion && Object.keys(this.availableFields).length > 0) {
            _.each(this.availableFields, (field, fieldSlug) => {
                this.selectedFieldsInputModels[fieldSlug] = (this.injector.get('$filter')('filter')(this.internalDefintion, {slug: fieldSlug}, true).length > 0);
            });

            this._checkWholeFieldGroupStates();
        }
    }

    _checkWholeFieldGroupStates() {
        const groupInactiveFields = {};
        _.each(this.selectableFields, (groupInfo) => {
            _.each(groupInfo.fields, (fieldInfo) => {
                if (!_.has(groupInactiveFields, groupInfo.key)) {
                    groupInactiveFields[groupInfo.key] = false;
                }

                if (!this.selectedFieldsInputModels[fieldInfo.slug]) {
                    groupInactiveFields[groupInfo.key] = true;
                }
            })

        });

        _.each(groupInactiveFields, (value, group) => {
            this.selectedGroupsInputModels[group] = !value;
        });
    }

    _initCheckboxModels() {
        _.each(this.availableFields, (fieldInfo, fieldSlug) => {
            this.selectedFieldsInputModels[fieldSlug] = false;
            this.selectedGroupsInputModels[fieldInfo.group] = false;
        })
    }

    _scrollToTop() {
        jQuery('html, body').animate({scrollTop: this.element.offset().top - 110}, 200);
        jQuery(this.element).find('.select-fields').animate({scrollTop: 0}, 200);
    }
}

AlGuestlistFormFieldSelectorComponentController.$inject = [
    '$scope',
    '$injector',
    '$element',
    'Alert'
];



// WEBPACK FOOTER //
// ./src/app/modules/guestlists/components/al-guestlist-editor/general/form-field-selector/controllers/component.js